import { render, staticRenderFns } from "./SepararCuentaComponent.vue?vue&type=template&id=6fb0b557"
import script from "./SepararCuentaComponent.vue?vue&type=script&lang=js"
export * from "./SepararCuentaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports